import { Center, Checkbox, Text, Title } from '@mantine/core';
import { useDomainItem } from './use-domain-item';
import { StyledListItem, TextWrapper } from './styles';

interface DomainItemProps {
  domain: string;
}

export const DomainItem = ({ domain }: DomainItemProps) => {
  const { isSelected, handleSelect } = useDomainItem(domain);

  return (
    <StyledListItem onClick={handleSelect}>
      <Center>
        <Checkbox checked={isSelected} readOnly />
      </Center>

      <TextWrapper>
        <Title order={4} fw={500}>
          {domain.charAt(0).toUpperCase() + domain.slice(1)}
        </Title>
      </TextWrapper>
    </StyledListItem>
  );
};
